import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { ApiService } from 'src/app/services/api-service/api.service';

@Component({
  selector: 'app-create-user',
  templateUrl: './create-user.component.html',
  styleUrls: ['./create-user.component.css'],
})
export class CreateUserComponent {
  registerForm = new FormGroup({
    firstName: new FormControl(''),
    lastName: new FormControl(''),
    email: new FormControl('', [Validators.required, Validators.email]),
    password: new FormControl('', Validators.required),
    confirmPassword: new FormControl('', Validators.required),
  });

  visibilityMapping = {
    password: false,
    confirmPassword: false,
  };

  constructor(
    private apiService: ApiService,
    public dialogRef: MatDialogRef<CreateUserComponent>
  ) {}

  viewPassword(field: 'password' | 'confirmPassword') {
    if (this.visibilityMapping[field]) {
      this.visibilityMapping[field] = !this.visibilityMapping[field];
    }
  }

  createUser() {
    const { firstName, lastName, email, password } = this.registerForm.value;
    this.apiService
      .postUser(
        'parkingAgent',
        firstName as string,
        lastName as string,
        email as string,
        password as string
      )
      .subscribe(
        () => {
          this.dialogRef.close();
        },
        (error) => {
          console.error('Error creating user', error);
        }
      );
  }
}
